export function initHasInnerErrorObject(obj: any): Object {
  Object.keys(obj).forEach((item) => {
    if (typeof obj[item] === 'object') {
      Object.keys(obj[item]).forEach((innerItem) => {
        obj[item][innerItem] = false;
      });
    } else {
      obj[item] = false;
    }
  });
  return obj;
}
